import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const Ticker = ({ items }) => {
    // state
    const [ textItems, setTextItems ] = useState(items);

    useEffect(() => {
        const handleResize = () => {
            // average char width is 19px
            const widthWidestChar = 19;

            // get estimated total line length of all chars from each array item combined
            const widthText = items.reduce((accumulator, currentValue) => accumulator + currentValue.bodyTextOnly.length, 0) * widthWidestChar;

            // get how many items required to fill the current window size
            let itemsRequired = 1;
            let windowFilled = widthText / window.innerWidth;
            while (windowFilled < 1) {
                itemsRequired = itemsRequired + 1;
                windowFilled = (widthText / window.innerWidth) * itemsRequired
            }

            setTextItems(Array(itemsRequired).fill(items).flat());
        };

        handleResize();
        window.addEventListener('resize', handleResize, { passive: true });
        return () => window.removeEventListener('resize', handleResize);
    }, [ items ]);

    return (
        <div className='ticker w-full flex overflow-hidden bg-white h-[44px]'>
            <ul className='ticker__items w-fit h-full flex flex-shrink-0 flex-grow-0'>
                {textItems.map((item, idx) => {
                    return (
                        <li
                            className='ticker__item flex-shrink-0 flex-grow-0 border-b border-r border-charcoal flex items-center justify-center whitespace-nowrap'
                            key={idx}>
                            <div
                                className='rich-text type-style-3 px-20 md:px-80'
                                dangerouslySetInnerHTML={{ __html: item.body}} />
                        </li>
                    );
                })}
            </ul>

            <ul className='ticker__items w-fit h-full flex flex-shrink-0 flex-grow-0'>
                {textItems.map((item, idx) => {
                    return (
                        <li
                            className='ticker__item flex-shrink-0 flex-grow-0 border-b border-r border-charcoal flex items-center justify-center whitespace-nowrap'
                            key={idx}>
                            <div
                                className='rich-text type-style-3 px-20 md:px-80'
                                dangerouslySetInnerHTML={{ __html: item.body}} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array
};

Ticker.propTypes = propTypes;

export default Ticker;
